import React from "react";

const PasswordChange = () => <div>{/* <h1>PasswordChange</h1> */}</div>;

export default PasswordChange;
